import styled, { css } from 'styled-components'
import colors from '../../constants/colors'
import { InputProps, TextAreaProps } from './Input.types'
import { inputVariant, inputWrapperVariant } from './variant'

export const StyledInput: React.FC<InputProps> = styled.input<InputProps>`
  ${(props) => inputVariant(props)}
`

export const PlainInput: React.FC<InputProps> = styled.input<InputProps>`
  ${(props) =>
    props.isPlain
      ? css`
          border: none;
          flex-grow: 1;
          flex: 1;
          line-height: 20px;
          width: 100%;
          &:focus {
            outline: none;
          }
          &::placeholder {
            color: ${colors.black25};
            font-size: '14px';
          }
          &:disabled {
            background-color: ${colors.black5};
            cursor: not-allowed;
          }
        `
      : inputVariant(props)}
`

export const InputWrapper: React.FC<InputProps> = styled.span<InputProps>`
  ${(props) => inputWrapperVariant(props)}
  background-color: ${(props) => (props.disabled ? colors.black5 : colors.white)};
  cursor: ${(props) => props.disabled && 'not-allowed'};
  display: flex;
  align-items: center;
`

export const Wrapper = styled.div<{ disabled: boolean }>`
  margin: 5px;
  cursor: pointer;
  width: 20px;
  height: 20px;
  position: relative;
  label {
    margin-left: 28px;
    white-space: nowrap;
  }
  &::before {
    content: '';
    opacity: ${(props) => (props.disabled ? 0 : 1)};
    border-radius: 100%;
    border: 1px solid ${colors.black50};
    background: ${colors.white};
    width: 100%;
    height: 100%;
    position: absolute;
    top: 0;
    box-sizing: border-box;
    pointer-events: none;
    z-index: 0;
  }
`

export const Fill = styled.div`
  background: ${colors.blue50};
  width: 0;
  height: 0;
  border-radius: 100%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
  transition: width 0.2s ease-in, height 0.2s ease-in;
  pointer-events: none;
  z-index: 1;

  &::before {
    content: '';
    opacity: 0;
    width: calc(20px - 4px);
    position: absolute;
    height: calc(20px - 4px);
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    border: 3px solid ${colors.blue10};
    border-radius: 100%;
  }
`

export const Radio = styled.input<React.HTMLProps<HTMLInputElement>>`
  opacity: 0;
  z-index: 2;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  margin: 0;
  cursor: pointer;

  &:focus {
    outline: none;
  }

  &:checked {
    & ~ ${Fill} {
      width: 16px;
      height: 16px;
      transition: width 0.2s ease-out, height 0.2s ease-out;

      &::before {
        opacity: 1;
      }
    }
  }
  &:disabled {
    opacity: 0;
    cursor: not-allowed;
    & ~ ${Fill} {
      background-color: transparent;
      opacity: 1;
      &::before {
        ${(props) =>
          !props.checked
            ? css`
                border: 1px solid ${colors.black50};
                width: 20px;
                height: 20px;
                background-color: ${colors.black10};
                opacity: 1;
              `
            : css`
                border: 3px solid ${colors.blue25};
                width: 16px;
                height: 16px;
                background-color: ${colors.blue50};
                opacity: 0.35;
              `}
      }
    }
  }
`

export const StyledTextArea: React.FC<TextAreaProps> = styled.textarea<TextAreaProps>`
  border-radius: 8px;
  border: solid 1px ${(props) => (props.isError ? colors.red50 : colors.black10)};
  padding: 12px 16px;
  font-family: inherit;
  font-size: 14px;
  &::placeholder {
    color: ${colors.black25};
    font-size: '14px';
  }
`
